// extracted by mini-css-extract-plugin
module.exports = {"collapsibleTableBox":"GridAdsetDetail_collapsibleTableBox_2E_uJ","priceAdjustment":"GridAdsetDetail_priceAdjustment_2Vctm"};